export const iconFontAwesomeTravelHotelBabyCarriage = (
	<i className="fa-solid fa-baby-carriage"></i>
);
